import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { richTextValidation } from 'validators';
import { FullColumn, RichTextEditor, TextButton, Typography, useDevice, useIsInBottomSheet } from 'seagull';
import { AIEdit24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useRichTextVariableIntegration } from '~/components/AgreementStudioPage/TemplateVariables/hooks/useRichTextVariableIntegration';
import { VariableInsertButton } from '~/components/AgreementStudioPage/TemplateVariables/VariableInsertButton/VariableInsertButton';
import { VariablePickerPopover } from '~/components/AgreementStudioPage/TemplateVariables/VariablePickerPopover/VariablePickerPopover';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { connectControllerToRichTextEditor } from '~/utils/react-hook-form.utils';
import styles from './ServiceDescription.module.scss';
export const GetServiceDescriptionTID = (parentTestId)=>getTestIds(parentTestId);
const ServiceDescription = (param)=>{
    let { testId, hideLabel = false, onChange = ()=>{}, onHelpMeWriteClick, disabledHelpMeWrite = false, isDrawerOpen = false, disabled = false } = param;
    const { SERVICE_DESCRIPTION_AI } = useFeatureFlags();
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const hideHelpMeWrite = isInBottomSheet || isMobileDevice;
    const { control, watch } = useFormContext();
    const isBundle = Boolean(watch('bundle'));
    const { ServiceDescriptionTestIds } = useMemo(()=>GetServiceDescriptionTID(testId), [
        testId
    ]);
    const editorElRef = useRef(null);
    const { enabled: variablesEnabled, toolbarButtonProps, pickerPopoverProps } = useRichTextVariableIntegration(editorElRef, {
        disabled
    });
    const isOnlyDisabledHelpMeWrite = !isDrawerOpen && disabledHelpMeWrite;
    const helpMeWriteButton = SERVICE_DESCRIPTION_AI && !!onHelpMeWriteClick && !hideHelpMeWrite ? /*#__PURE__*/ _jsx("div", {
        className: styles.helpMeWriteButtonWrapper,
        children: /*#__PURE__*/ _jsx(TextButton, {
            tooltip: isOnlyDisabledHelpMeWrite && {
                title: 'Please name this service first',
                placement: 'top'
            },
            prefixIcon: /*#__PURE__*/ _jsx("span", {
                className: cn({
                    [styles.iconWrapper]: !isDrawerOpen
                }),
                children: /*#__PURE__*/ _jsx(AIEdit24, {})
            }),
            underline: "none",
            weight: "normal",
            skin: isDrawerOpen ? 'focusPrimary' : 'primary',
            disabled: isOnlyDisabledHelpMeWrite,
            onClick: onHelpMeWriteClick,
            testId: ServiceDescriptionTestIds.HelpMeWriteButton(),
            children: /*#__PURE__*/ _jsx("span", {
                className: cn({
                    [styles.textWrapper]: !isDrawerOpen
                }),
                "data-text": "Help me write",
                children: "Help me write"
            })
        })
    }) : null;
    const variableButton = variablesEnabled ? /*#__PURE__*/ _jsx(VariableInsertButton, _object_spread({}, toolbarButtonProps)) : null;
    const toolbarActions = /*#__PURE__*/ _jsxs("div", {
        className: styles.toolbarActionsRow,
        children: [
            variableButton,
            variableButton && helpMeWriteButton && /*#__PURE__*/ _jsx("div", {
                className: styles.toolbarDivider
            }),
            helpMeWriteButton
        ]
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(FullColumn, {
                gap: 8,
                alignItems: "start",
                children: [
                    !hideLabel && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "secondary",
                        testId: "".concat(testId, "-label"),
                        children: isBundle ? 'Bundle description' : 'Service description'
                    }),
                    /*#__PURE__*/ _jsx(Controller, {
                        control: control,
                        name: "description",
                        rules: richTextValidation(),
                        render: (renderProps)=>{
                            const connected = connectControllerToRichTextEditor(renderProps);
                            const originalEditorRef = connected.editorRef;
                            return /*#__PURE__*/ _jsx(RichTextEditor, _object_spread_props(_object_spread({
                                editorHeight: 310,
                                placeholder: "Describe service (Optional)",
                                testId: testId
                            }, connected), {
                                editorRef: (el)=>{
                                    editorElRef.current = el;
                                    if (typeof originalEditorRef === 'function') {
                                        originalEditorRef(el);
                                    }
                                },
                                onChange: (v)=>{
                                    onChange(v);
                                    connected.onChange(v);
                                },
                                toolbarActions: toolbarActions,
                                disabled: disabled
                            }));
                        }
                    })
                ]
            }),
            variablesEnabled && /*#__PURE__*/ _jsx(VariablePickerPopover, _object_spread({}, pickerPopoverProps))
        ]
    });
};
export default ServiceDescription;
